// Central registry of Alpha explainer videos. Keyed by service slug so
// landing pages can pick up the right one automatically.
export const VIDEOS = {
  sil: {
    title: "Supported Independent Living",
    blurb: "See how Alpha's 24/7 SIL support works day-to-day in a real home.",
    url: "https://youtu.be/56GXPWkVxUM",
    poster: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  },
  "community-participation": {
    title: "Community Participation",
    blurb: "Real outings, real connection — community supports that feel like life, not programs.",
    url: "https://youtu.be/z7rg7cYlLOk",
    poster: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  },
  "support-worker": {
    title: "Support workers & our homes",
    blurb: "Meet the team and step inside an Alpha home — the care, the craft, the difference.",
    url: "https://youtu.be/2RJpXcgC6h4",
    poster: "https://images.unsplash.com/photo-1516733725897-1aa73b87c8e8?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  },
};

// Array for iteration (preserve order: SIL first, then community, then team)
export const VIDEO_LIST = [VIDEOS.sil, VIDEOS["community-participation"], VIDEOS["support-worker"]];

// Convert any YouTube / Vimeo URL to an embeddable src.
// Captions on by default (cc_load_policy=1) — accessibility + silent autoplay.
export function toEmbed(url) {
  if (!url) return "";
  const yt = (id) =>
    `https://www.youtube.com/embed/${id}?autoplay=1&rel=0&modestbranding=1&playsinline=1&cc_load_policy=1&hl=en&cc_lang_pref=en`;
  try {
    if (url.includes("youtube.com/watch")) return yt(new URL(url).searchParams.get("v"));
    if (url.includes("youtu.be/")) return yt(url.split("youtu.be/")[1].split(/[?&]/)[0]);
    if (url.includes("youtube.com/embed/")) return url;
    if (url.includes("vimeo.com")) {
      const id = url.split("vimeo.com/")[1].split(/[?&]/)[0];
      return `https://player.vimeo.com/video/${id}?autoplay=1&title=0&byline=0&texttrack=en`;
    }
  } catch (_) {
    // Malformed URL — fall through to return the original string.
  }
  return url;
}

// YouTube thumbnail helper (HD, with graceful fallback)
export function ytThumb(url) {
  if (!url) return "";
  let id;
  if (url.includes("youtu.be/")) id = url.split("youtu.be/")[1].split(/[?&]/)[0];
  else if (url.includes("youtube.com/watch")) id = new URL(url).searchParams.get("v");
  if (!id) return "";
  return `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
}

// Fallback (smaller) thumbnail — hqdefault is always present on YouTube.
export function ytThumbFallback(url) {
  if (!url) return "";
  let id;
  if (url.includes("youtu.be/")) id = url.split("youtu.be/")[1].split(/[?&]/)[0];
  else if (url.includes("youtube.com/watch")) id = new URL(url).searchParams.get("v");
  if (!id) return "";
  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
}
